import React from 'react';
import Grid from '@material-ui/core/Grid';
import strings from 'strings';
import FPActionButton from 'UI/components/atoms/FPActionButton';
import FPIcon from 'UI/components/atoms/FPIcon';
import Text from 'UI/components/atoms/Text';
import { When } from 'UI/components/atoms/When';
import ProfileAvatarsList from 'UI/components/organisms/ProfileAvatarsList';
import { SearchProjectPrivacyScopes } from 'UI/constants/defaults';
import { SvgLock, SvgUnlock } from 'UI/res';

import { useTitleDetailsStyles } from '../styles';
import { getQueryShortFormatDate } from '../utils';

const privacyIcons = {
  [SearchProjectPrivacyScopes.private.id]: SvgLock,
  [SearchProjectPrivacyScopes.public.id]: SvgUnlock
};

const { actions: actionsCopies } = strings.searchProjects.preview;

/**
 * @param {Object} props
 * @param {number} [props.avatarsToShow]
 * @param {boolean} [props.canManageCollaborations]
 * @param {boolean} [props.canViewHistoryLog]
 * @param {Array<SearchProjectCollaborationsTypes>} [props.collaborators]
 * @param {Object} props.searchProject
 * @param {Function} props.onOpenActivityDrawer
 * @param {Function} props.onOpenCollaborationsDrawer
 */
const SearchProjectsTitleDetails = ({
  avatarsToShow = null,
  canManageCollaborations = false,
  canViewHistoryLog = false,
  collaborators = null,
  searchProject,
  onOpenActivityDrawer,
  onOpenCollaborationsDrawer
}) => {
  const classes = useTitleDetailsStyles();
  const lastSentBulkDate = getQueryShortFormatDate(
    searchProject.lastBulkSentDate,
    format => format.SimpleDateTimeHyphen
  );
  const infoString = `Last Bulk Sent On ${lastSentBulkDate}`;

  return (
    <Grid container>
      <When condition={searchProject.privacyScope}>
        <Grid container item alignItems="center">
          <FPIcon
            component={privacyIcons[searchProject.privacyScope?.id]}
            size={16}
            className={classes.privacyIcon}
          />
          <Text text={`${searchProject.privacyScope?.title} /`} />
          <Text className={classes.infoText} text={infoString} variant="body2" />
          <When condition={canViewHistoryLog}>
            <FPActionButton
              className={classes.historyLogButton}
              onClick={onOpenActivityDrawer}
              size="small"
              text={actionsCopies.moreOptions.menuItems.historyLog}
              variant="text"
            />
          </When>
        </Grid>
      </When>
      <Grid container item>
        <ProfileAvatarsList
          options={collaborators}
          optionsToShow={avatarsToShow}
          showAddButton={canManageCollaborations && !searchProject.isArchived}
          addButtonProps={{
            tooltipProps: {
              title: actionsCopies.moreOptions.menuItems.manageCollabs,
              placement: 'right'
            },
            onClick: onOpenCollaborationsDrawer
          }}
        />
      </Grid>
    </Grid>
  );
};

export default SearchProjectsTitleDetails;
